/* eslint-ignore */
// @ts-nocheck
import React, { Component } from 'react';

import Document from './Steps/document';
import SelectEmail from './Steps/selectEmail';
import SignUpWithEmail from './Steps/signUpWithEmail';
import SelectNumber from './Steps/selectNumber';
import SignUpWithPhone from './Steps/signUpWithPhone';
import SignUpWithInvoices from './Steps/signUpWithInvoices';
import Uac from './Steps/uac';
import Confirmation from './Steps/confirmation';

class SignupComponent extends Component {
  render() {
    const { step } = this.props;
    switch (step) {
      case 1: {
        return <Document />;
      }
      case 2: {
        return <SelectEmail />;
      }
      case 2.1: {
        return <SignUpWithEmail />;
      }
      case 3: {
        return <SelectNumber />;
      }
      case 3.1: {
        return <SignUpWithPhone />;
      }
      case 4: {
        return <SignUpWithInvoices />;
      }
      case 4.1: {
        return <Uac />;
      }
      case 5: {
        return <Confirmation />;
      }
      default: {
        return <Document />;
      }
    }
  }
}

export default SignupComponent;
